module.exports = __webpack_public_path__ + "static/media/sombra-inferior-capa.a220bf2a.svg";